import constant from '../../constant';
import request from '../../../utils/request';
import { GET_HOT_COMMENT_NEW } from '../../../urls'
import { showTip } from '../../../utils'


const getHotComment = (params = {}) => {
  return async (dispatch) => {

    try {
      if (!window._configs.commentProfileID || !window._configs.profileIdMatchList || window._configs.profileIdMatchList.indexOf(window._configs.commentProfileID) === -1) {
        return null;
      }
      const sDocId = params.sDocId
      if (sDocId) {
        const sUserId = params.sUserId

        const res = await request.get(GET_HOT_COMMENT_NEW, {
          docId: sDocId,
          sUserId
        })

        if (res.code === 0) {
          const comments = (res.data.comments || []).slice(0, 2);
          dispatch(getHotCommentSuccess({comments,totalNum: res.data.totalNum || 0}))
        }
      } else {
        console.log('missed shSid')
      }

    } catch (error) {
      console.log('getHotCommentNew error',error)
      showTip(error.msg || '服务异常，请稍后再试')
    }
  }
}


const getHotCommentSuccess = (commentNew) => {
  return {
    type: constant.COMMENT.GET_HOT_COMMENT_NEW,
    commentNew
  }
}

export default {
  getHotCommentSuccess,
  getHotComment
}